import React from 'react';
import { Route, Navigate, Link } from 'react-router-dom';
import Loader from '../Loader';

interface PublicRouteProps {
  element: React.ReactElement;
  isLoggedIn: boolean;
}

const PublicRoute: React.FC<PublicRouteProps> = ({ element, isLoggedIn }) => {
 
  return !isLoggedIn ? element : <Loader/>
};

export default PublicRoute;

// <div className='w-full h-[100vh] flex items-center justify-center text-2xl'>
{/* <div >Session Expired Please Login Again : <Link to={'/login'} className='text-blue-500 hover:underline'> Go to Login</Link></div>
</div>; */}